import {createContext, useContext, useEffect, useState} from "react";
import {useChangeEffect} from "../../js/util";

const TabsContext = createContext(null);

export const Tabs = ({ children, defaultValue, onChange = (tab) => {} }) => {
    const [active, setActive] = useState(defaultValue);

    useChangeEffect(() => {
        onChange(active);
    }, [active]);

    return (
        <TabsContext.Provider value={{ active, setActive }}>
            <div className={"tabs"}>
                {children}
            </div>
        </TabsContext.Provider>
    );
};

export const TabsList = ({ children }) => {
    return <div role="tab-list">{children}</div>;
};

export const TabsTrigger = ({ value, children }) => {
    const { active, setActive } = useContext(TabsContext);

    return (
        <button
            role="tab"
            className={"tab-selector "+(active === value ? "active" : "")}
            aria-selected={active === value}
            onClick={(e) => {
                e.preventDefault();
                setActive(value);
            }}
        >
            {children}
        </button>
    );
};

export const TabsContent = ({ value, children }) => {
    const { active } = useContext(TabsContext);

    return active === value ? (
        <div role="tabpanel" className={"tab-panel"}>{children}</div>
    ) : null;
};